var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useState } from 'react';
import { t } from '@lingui/core/macro';
import { Box, Loader, Switch, useToast } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useEsigningSettings } from 'app/domains/esigning/hooks/useEsigningSettings';
import { useUpdateEsigningSettings } from 'app/domains/esigning/hooks/useUpdateEsigningSettings';
import { GroupMessageField } from './GroupMessageField';
import { Setting } from '../Setting';
export function GroupMessage() {
    const { groupMessage } = useEsigningSettings();
    const { updateGroupMessage } = useUpdateEsigningSettings();
    const { addToast } = useToast();
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState(groupMessage || '');
    const [groupMessageActive, setGroupMessageActive] = useState(Boolean(groupMessage));
    const updateSettingsMessage = (newMessage) => __awaiter(this, void 0, void 0, function* () {
        const parsedMessage = newMessage.trim();
        const isMessageChanged = parsedMessage !== groupMessage;
        if (!isMessageChanged) {
            return;
        }
        setLoading(true);
        setMessage(parsedMessage);
        try {
            yield updateGroupMessage(parsedMessage);
        }
        catch (_a) {
            addToast({
                appearance: 'danger',
                title: t({
                    message: 'Could not update signing order setting',
                    comment: 'Toast message for error when updating eSigning signing order setting',
                }),
            });
        }
        setLoading(false);
    });
    const handleSwitchChange = (checked) => {
        setGroupMessageActive(checked);
        if (!checked) {
            updateSettingsMessage('');
        }
        else {
            updateSettingsMessage(message);
        }
    };
    const handleBlur = (value) => {
        updateSettingsMessage(value);
    };
    const handleChange = (value) => {
        setMessage(value);
    };
    return (<Setting icon={loading ? <Loader size={8}/> : <Falcon icon="envelope"/>} label={t({
            comment: 'Label for e-signing setting add message',
            message: 'Add message',
        })} description={t({
            comment: 'Description for e-signing setting add message',
            message: 'Include a message to all parties',
        })} endElement={<Switch checked={groupMessageActive} disabled={loading} onCheckedChange={handleSwitchChange}/>}>
      {groupMessageActive && (<Box mt="md">
          <GroupMessageField value={message} disabled={loading} onBlur={handleBlur} onChange={handleChange}/>
        </Box>)}
    </Setting>);
}
